export default {
  playerPage: {
    errorTitle: 'An error occurred while reading the sheet music. This problem can occur if another application using sound (e.g., YouTube) is running in parallel with Tokatab. Please restart the application. If the problem persists, contact support.',
    restartButton: 'Restart application',
    songUnavailable: 'Sorry, this song doesn\'t seem to be available at the moment. Please try again later.',
    backToHome: 'Back to home'
  },

  playerHeaderBar: {
    exitTutorial: 'Exit tutorial',
    learningMode: 'Learning mode',
    partitionUnavailable: 'Sheet music unavailable',
    pieces: 'Songs',
    challenges: 'Challenges',
    pedagogicalPath: 'Educational Path',
    levelEvaluation: 'Level evaluation',
    exercise: 'Exercise',
    step: 'Step'
  },

  playerControlsBar: {
    exitTutorial: 'Exit',
    listenCarefully: 'Listen carefully, here is the part we will study.',
    demo: 'Demo',
    skip: 'Skip',
    finish: 'Finish',
    display: 'Display'
  },

  validationModal: {
    title: 'How was this',
    difficulties: {
      veryHard: 'Too difficult',
      hard: 'Difficult',
      adapted: 'Just right',
      easy: 'Easy',
      veryEasy: 'Too easy'
    },
    revisionMessage: 'Alright, I take your feedback into account!',
    backToHome: 'Return to home',
    continue: 'Continue',
    modifyChoice: 'Modify my choice',
    calculatingProgress: 'Updating your progress',

    // Feedback texts for difficulty level 5 (too hard)
    veryHardResponses: {
      response1: 'Ok! We\'ll work on it later when it\'s easier.',
      response2: 'Alright! We\'ll work on it then.',
      response3: 'Noted! I\'ll take this feedback into account for my future recommendations.',
      response4: 'Understood! We\'ll play it again when appropriate.'
    },

    // Feedback texts for difficulty level 4 (hard)
    hardResponses: {
      response1: 'I note! You\'ll see, we\'ll review it later and it will seem easier.',
      response2: 'Bravo for your tenacity! I plan to have you review it later.',
      response3: 'It\'s often by confronting difficulty that we progress! In a few weeks, this exercise will seem easier.',
      response4: 'Understood! We\'ll work on it again later.'
    },

    // Feedback texts for difficulty level 3 (adapted)
    adaptedResponses: {
      response1: 'Understood! We\'ll maybe review it once or twice.',
      response2: 'Great! We\'ll play it again once or twice in some time.',
      response3: 'Got it. I’ll adjust your recommendations.',
      response4: 'Agreed! I note that it will require little revision.'
    },

    // Feedback texts for difficulty level 2 (easy)
    easyResponses: {
      response1: 'Agreed! In that case, I consider it won\'t be necessary to review it.',
      response2: 'Great! I consider you master it 100%.',
      response3: 'Great! I feel we\'re going to progress quickly together.',
      response4: 'Ok! If it\'s easy for you, then it means it won\'t be necessary to review it.'
    },

    // Feedback texts for difficulty level 1 (too easy)
    veryEasyResponses: {
      response1: 'Agreed! I\'ll take this feedback into account.',
      response2: 'Ok! I consider you master it 100% and it won\'t be necessary to review it.',
      response3: 'Great! So it won\'t be necessary to review it later.',
      response4: 'Ok! If it\'s very easy for you, then I\'ll take that into account.'
    },
    yourScore: 'Your score:',
    congratulations: 'Congratulations, you can move to the next step!',
    restart: 'Restart',
    keepWorking: 'Let\'s work on this part some more to reach 90%.',
    skip: 'Skip',
    loadingTexts: {
      text1: "I take into account your playing and feedback…",
      text2: "I update your progress…",
      text3: "I prepare the next steps…",
      text4: "I refine your next recommendations…",
      text5: "I finalize the last adjustments…",
      text6: "It\'s almost ready…"
    }
  },

  evaluationModal: {
    title: 'How was it?',
    fail: {
      label: 'It was difficult',
      subLabel: 'Let\'s try again',
      success: 'Let\'s try again'
    },
    good: {
      label: 'I\'m doing well',
      subLabel: 'Continue',
      success: 'Oh yeah!'
    },
    easy: {
      label: 'Too easy!',
      success: 'Oh Yeah!'
    },
    yourScore: 'Your score:',
    congratulations: 'Congratulations, you can move to the next step!',
    restart: 'Restart',
    continue: 'Continue',
    keepWorking: 'Let\'s work on this part some more to reach 90%.',
    skip: 'Skip',
    finalizingEvaluation: 'Finalizing your evaluation...',
    mayTakeMoment: 'This may take a few moments.'
  },

  successModal: {
    defaultTitle: 'Great!',
    continue: 'Continue',
    home: 'Home'
  },

  skillUpdateComponent: {
    title: 'Skill progress',
    loading: 'Loading skills...',
    error: 'An error occurred while loading skills.',
    error2: "If the error persists, please contact support."
  },

  successRecommandations: {
    title: 'Here\'s what I suggest next',
    challengeLabel: 'Apply your skills musically with a challenge',
    continueSkill: 'Keep improving this skill',
    startNewSkill: 'Start working on a new skill',
    workSomethingElse: 'Work on something else'
  },

  playerView: {
    listeningActive: 'Listening active'
  },

  bigSuccessComponent: {
    defaultTitle: 'Mission Accomplished'
  },

  audioCaptureButton: {
    activate: 'Activate listening mode',
    deactivate: 'Deactivate listening mode',
    modalTitle: 'Listening mode',
    explanationPart1: 'Throughout your journey by clicking on the button',
    explanationPart2: 'you will activate "listening mode".',
    explanationPart3: 'The Tokatab sound is then cut to avoid scrambling the frequencies picked up by the microphone.',
    doNotShowAgain: 'Don\'t show again',
    continue: 'Continue',

    microphoneAccessTitle: 'Listening mode',
    microphoneAccessMessage: 'You refused microphone access. If you want to use "listening mode", you must allow access to your microphone:',
    privacyMessage: 'We respect your privacy, recordings stay on your device and are not saved!',
    close: 'Close',
    instructionsButtons: {
      windows: 'See instructions for Windows',
      mac: 'See instructions for Mac'
    },
    activateListening: 'Activate listening mode',

    mustAllowMicrophone: 'You must allow microphone to use listening mode',
    notCompatible: 'Listening mode is not compatible with your device',
    listeningActivated: 'I activated listening to your notes, I disable sound to hear you well.',
    listeningDeactivated: 'I deactivated listening mode.'
  },

  playerKaraokeTimeline: {
    lyricsInRhythm: 'Lyrics in rhythm',
    lyricsInText: 'Lyrics in text'
  },

  challengeController: {
    contentType: 'this challenge'
  },

  sectionExerciseController: {
    contentType: 'this exercise'
  },

  playerSongClassViewController: {
    incredible: 'Incredible!',
    bravo: 'Bravo!',
    great: 'Great!',
    juryDescription: 'If I had been in the jury I would have turned around! You are now ready to go on tour',
    goToSinging: 'Go to singing',
    courseMenu: 'Course menu',
    demonstration: 'Demonstration',
    readyToSing: 'You are now ready to practice singing this song',
    readyToShowOff: 'Great! You are ready to show off on the piano',
    masterParts: 'You have mastered the {partName} part, you can now focus on the other parts.',
    masterSection: 'You have mastered the {sectionName} section, you can now focus on the other sections.',
    firstStepNotification: 'You are at the first step of the course, it is impossible to go back.'
  },

  abstractPlayerSuggestionController: {
    scoreMessages: {
      veryLow: 'Ouch ouch ouch, your score is',
      low: 'Not bad! Your score is',
      medium: 'Almost there! Your score is',
      high: 'Nice work! Your score is',
      perfect: 'Perfect! No mistakes. Your score is 100%!'
    },
    actions: {
      restart: 'Restart',
      validate: 'Validate',
      slower: 'Try slower',
      faster: 'Increase tempo',
      activate: 'Activate',
      previousStep: 'Go back to previous step'
    }
  },

  suggestionController: {
    goodWorkFaster: 'Looks like you worked well! Why not try at a faster tempo?',
    goodWorkFasterNow: 'Looks like you worked well! Let\'s move to a faster tempo!',
    validateChallenge: 'Let\'s validate this challenge!',
    nextStep: 'Let\'s move to the next step!',
    nextExercise: 'Let\'s move to the next exercise!',
    readyValidateChallenge: 'Ready to validate this challenge?',
    readyNextStep: 'Ready to move to the next course step?',
    readyNextExercise: 'Ready to move to the next exercise?',
    trySlower: 'Maybe you should try with a slower tempo?',
    challengeNotAdapted: 'This challenge may not yet be adapted to your level.',
    memorize: 'Sometimes, it\'s better to take time to memorize the previous step well!',
    needMoreTime: 'It\'s normal to sometimes need more time!',
    wellPlayed: 'Well played. Do you want to speed up?',
    wellPlayedValidate: 'Well played. Do you want to validate?',
    fasterThanMusic: 'You\'re going faster than the music! Do you want to validate?',
    oneMoreRound: 'One more round and we move on?',
    setupMidi: 'To fully enjoy Tokatab, connect your MIDI piano or configure your microphone.',
    setupButton: 'Configure',
    acquiredPiano: 'Have you acquired a piano? To fully enjoy Tokatab, connect your piano or configure your microphone.',
    setupPianoButton: 'Configure my piano',
    activateListening: 'To help you, activate listening mode or connect your piano.'
  },

  playerTimerController: {
    restart: 'Restart',
    next: 'Next',
    nextStep: 'Next step'
  },

  loadingTimeline: {
    loading: 'Loading content...'
  },

  playerPartitionTimeline: {
    loadingError: 'Sheet music loading error'
  },

  loopParameters: {
    types: {
      none: 'None',
      play: 'All',
      part: 'Part',
      section: 'Section',
      rhythmicBloc: 'Rhythm',
      list: 'Sequence'
    }
  },

  visualParameters: {
    handLabels: {
      leftHand: 'left hand',
      rightHand: 'right hand',
      bothHands: 'both hands'
    },
    timelineLabels: {
      left: 'Left Hand',
      right: 'Right Hand',
      lyrics: 'Lyrics'
    }
  },

  soundParameters: {
    soundLabels: {
      main: 'Global',
      leftHand: 'Left Hand',
      rightHand: 'Right Hand',
      melody: 'Melody',
      metronome: 'Metronome'
    }
  },

  playerControllers: {
    congratulations: 'Congratulations!',
    close: 'Close',
    continue: 'Continue',
    validate: 'Validate',
    faster: 'Faster',
    slower: 'Slower',
    previousStep: 'Previous step',
    letsGo: 'Let\'s go!',
    tooHard: 'It\'s too hard',
    youKnowHowToPlay: 'You now know how to play',
    backToClassMenu: 'Back to course menu',
    tutorialComplete: 'You completed the tutorial!',
    onHomePage: 'On the home page, you will find missions to complete to familiarize yourself with the application.',
    discoverApp: 'Continue',
    restart: 'Restart!',
    evaluationComplete: 'You completed the evaluation!'
  },

  loopSelector: {
    repetition: 'Repetition'
  },

  tempoController: {
    slow: 'Slow',
    medium: 'Medium',
    normal: 'Normal',
    pass100Percent: 'Go to 100%'
  },

  timelineVisibilityButtons: {
    sheetMusicNotAvailable: 'Sheet music is not available for this content.',
    textFeedback: 'Text feedback',
    hide: 'Hide',
    show: 'Show',
    fingers: 'Fingerings',
    notes: 'Notes',
    fingersAndNotes: 'Fingerings and Notes',
    leftHand: 'Left Hand',
    rightHand: 'Right Hand',
    lyrics: 'Lyrics'
  },

  timelineVisibilitySwitch: {
    hide: 'Hide',
    show: 'Show'
  },

  metronomeSwitch: {
    activate: 'Activate metronome',
    deactivate: 'Deactivate metronome',
    metronome: 'Metronome'
  },

  soundController: {
    volumes: 'Volumes',
    activateSound: 'I turn on the {soundType} sound',
    deactivateSound: 'I turn off the {soundType} sound',
    focusOnLearning: 'that you can focus on what you are going to learn.',
    familiarizeWithSinging: 'that this piano part accompanies"',
    familiarizeWithPlaying: 'that you can familiarize yourself with what you will play later.',
    leftHand: 'left hand',
    rightHand: 'right hand',
    melody: 'melody',
    main: 'global',
    metronome: 'metronome',
    soundLabels: {
      main: 'Global',
      leftHand: 'Left Hand',
      rightHand: 'Right Hand',
      melody: 'Melody',
      metronome: 'Metronome'
    }
  },

  volumeSwitch: {
    mute: 'Mute',
    activate: 'Activate',
    sound: 'sound'
  },

  welcomeModalHeaderButton: {
    back: 'Back'
  },

  playerChallengeController: {
    backHome: 'Return to home',
    home: 'Home',
    back: 'Back',
    alreadyValidated: 'You have already validated this challenge',
    mustPlayAt100: 'You must successfully play this excerpt at 100% tempo to validate it.',
    toFinishChallenge: 'To finish this challenge you must play <b>{handConfig}</b> at <b>100%</b> of the target tempo!',
    presentTokatab1: 'Let me show you how to play with Tokatab through a first challenge “Tuto”.',
    presentTokatab2: 'Challenges are short practical excerpts designed to help you review and apply your piano skills.',
    presentTokatab3: 'Like all content in the app, you’ll need to play this excerpt successfully at 100% tempo to complete it.',
    tooComplex: 'If the challenge is too complex for you, you can try at a slower speed!'
  },

  playerSectionExerciseController: {
    backToLessons: 'Back to lessons',
    nextExercise: 'Next exercise',
    backHome: 'Return to home',
    home: 'Home',
    back: 'Back',
    next: 'Next',
    alreadyValidated: 'You have already validated this exercise',
    alreadyValidated2: ", but since you found it difficult, we suggest you work on it again",
    whatIFind: 'What you’ll work on',
    skills: 'Skills',
    data: 'Data',
    skillsIFind: 'In this exercise, here are the skills we will work on together',
    handprintsList: 'List of exercise hand shapes',
    rhythmicsList: 'List of exercise rhythms',
    revisionIntro: 'You validated this exercise on {date}{difficulty}. Let\'s review it!',
    difficulties: {
      veryEasy: 'very easy',
      easy: 'easy',
      adapted: 'just right',
      hard: 'hard',
      veryHard: 'very hard'
    },
    foundItPrefix: ' and found it ',
    tooComplex: 'If the exercise is too complex for you, you can try at a slower speed!',
    listExerciseHandprints: 'List of exercise hand shapes',
  },

  playerSongViewController: {
    congratulations: 'Congratulations!',
    youKnowHowToPlay: 'You now know how to play',
    close: 'Close',
    alreadyStarted: 'You have already started the course on this piece!',
    wantToContinue: 'Do you want to resume its progress?',
    finished: 'You have finished the course of this piece!',
    whatToDo: 'What do you want to do?',
    notStarted: 'You have not yet started the course on this piece. Do you want help learning it?',
    play: 'Play',
    learnAlone: 'I learn alone',
    learnWithTeacher: 'I learn with the teacher',
    reviewCourse: 'Review the course',
    resumeCourse: 'Resume the course',
    pieces: 'Pieces'
  },

  playerEvaluationController: {
    congratulations: 'Congratulations!',
    successDescription: 'You have succeeded in this challenge',
    nextStep: 'Next step',
    evaluationCompleteSubtitle: 'You have completed the evaluation!',
    personalizedPathDescription: 'You can now access your personalized learning path! And progress easily by following the suggested exercises',
    restart: 'Restart',
    additionalTries: '2 additional tries',
    finishEvaluation: 'Finish the evaluation',
    yourLevel: 'Your level:',
    home: 'Home',
    levelEvaluationTitle: 'Evaluation of your level',
    needPiano: 'You will need a piano to perform this test.',
    challengeIntro: 'I will offer you a series of small challenges that become increasingly difficult. We will stop your test as soon as one of these challenges <b>seems too complicated for you!</b> Don\'t worry if it becomes difficult quickly: I will be there afterwards to help you discover and work on the basics and the concepts you are missing.',
    threeTries: 'For each challenge, you will have <b>3 attempts</b> to play it perfectly.',
    finishTestAccess: '<b>Finish the test</b> to access your personalized learning path!',
    threeTriesReminder: 'As a reminder, you will have <b>3 attempts</b> per exercise. So concentrate well!',
    doItLater: 'I\'ll do it later',
    start: 'Start',
    resume: 'Resume',
    finishLater: 'finish later',
    fingerReminder: 'Reminder about fingerings',
    challenge: 'Challenge:',
    letsGo: 'Let\'s go!',
    thisStep: 'this step',
    cantDoIt: 'Can\'t do it anymore? Do you want to finish the test here?',
    noTryAgain: 'No, I\'ll try again',
    yesFinish: 'Yes, finish the test',
    step: 'Step',
    additionalTriesNotification: 'You exceptionally have two additional attempts to succeed in this step! Click the play button when you feel ready!',
    triesRemaining: 'You have {count} trial(s) remaining! Click the play button when you feel ready!',
    tooHard: "Too hard"
  },

  evaluationSuggestionController: {
    trialsRemaining: 'You have {count} trial(s) remaining to validate {name}!'
  },

  playerLoader: {
    loading: 'Loading your latest progress. This may take a few moments, thank you for your patience.'
  }
};